export const GET_ONE_ARTICLE = "GET_ONE_ARTICLE" ; 
export const GET_LIKED_BY = "GET_LIKED_BY" ;
export const CLEAR = 'CLEAR'

export const FOLLOWUSER = 'FOLLOWUSER' ; 
export const UNFOLLOWUSER = 'UNFOLLOWUSER' ;

export const BOOKMARK_ARTICLE = 'BOOKMARK_ARTICLE';
export const UNBOOKMARK_ARTICLE = 'UNBOOKMARK_ARTICLE';

export const LIKE_ARTICLE = 'LIKE_ARTICLE';
export const UNLIKE_ARTICLE = 'UNLIKE_ARTICLE';

export const CREATE_COMMENT  = "CREATE_COMMENT" ; 
export const GET_COMMENTS = "GET_COMMENTS" ;
export const DELETE_COMMENT = "DELETE_COMMENT" ; 
